import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BellRing, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StockAlertForm = ({ lookupKey }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [sending, setSending] = useState(false);

  const submit = async () => {
    const value = email.trim();
    if (!value || !value.includes("@")) {
      toast.error("Pop in a valid email address");
      return;
    }
    setSending(true);
    try {
      const res = await axios.post(`${API}/stock-alerts`, { email: value, lookup_key: lookupKey });
      if (res.data.status === "in_stock") {
        toast.success("Good news — it's available already!");
      } else {
        toast.success("You're on the list — we'll email you the moment it's available");
      }
      setDone(true);
    } catch {
      toast.error("Couldn't save that just now — try again in a moment");
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <p className="mt-3 inline-flex items-center gap-2 text-xs font-bold text-[#4A148C]" data-testid={`notify-done-${lookupKey}`}>
        <Check size={14} strokeWidth={3} /> You're on the list
      </p>
    );
  }

  return (
    <div className="mt-3 w-full max-w-xs" data-testid={`notify-form-${lookupKey}`}>
      <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-[#2B0B3C]/60 mb-1.5" data-testid={`notify-label-${lookupKey}`}>
        Email me when it's available
      </p>
      <div className="flex gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="you@email.com"
          data-testid={`notify-email-${lookupKey}`}
          className="h-10 min-w-0 w-full rounded-full border border-[#2B0B3C]/15 bg-white px-4 text-xs font-medium text-[#2B0B3C] placeholder:text-[#2B0B3C]/40 outline-none focus:border-[#4A148C] transition-colors duration-200"
        />
        <button
          onClick={submit}
          disabled={sending}
          aria-label="Notify me when available"
          data-testid={`notify-submit-${lookupKey}`}
          className="shrink-0 h-10 w-10 rounded-full bg-[#2B0B3C] text-white flex items-center justify-center hover:bg-[#FF6B00] transition-colors duration-200 disabled:opacity-50"
        >
          <BellRing size={15} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
};
